import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "@/app/App";
import { installClientMonitoring } from "@/lib/monitoring";
import { registerServiceWorker } from "@/lib/pwa/registerServiceWorker";
import { flushPendingSaves } from "@/lib/api/clients";
import "@/index.css";

installClientMonitoring();
registerServiceWorker();

// Erzwingt ausstehende debounced Client-Saves (350ms-Fenster), bevor die Seite
// verlassen wird — die PUT-Requests laufen dank keepalive:true auch nach dem
// Navigationsstart weiter. Ohne dies könnte z. B. ein Onboarding-Abschluss
// direkt vor einem Seitenwechsel verloren gehen.
window.addEventListener("beforeunload", () => {
  flushPendingSaves();
});

const rootElement = document.getElementById("app-root");
if (!rootElement) {
  throw new Error("#app-root wurde im DOM nicht gefunden.");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
